import { FieldLabelEnhancerType } from '../types/FieldTypes'

export const maxScoreFieldValue = 100

//#region Tooltip constants
export const FIELD_LABEL_TOOLTIP_ID = 'field-label-tooltip'

export const FIELD_LABEL_DATA_ATTRIBUTE = 'data-field-name'

export const FIELD_HELPTEXT_DATA_ATTRIBUTE = 'data-field-helptext'
//#endregion

export const DEFAULT_FIELD_LABEL_ENHANCERS: Array<FieldLabelEnhancerType> = [
   'HELP_TEXT',
   'FEE_CALCULATION'
]

export const FIELD_NAME_AND_HELPTEXT_TOOLTIP_ID =
   'field-name-and-help-text-tooltip'
